var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMingcuteLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:lock-fill",
    clipPath: "url(#clip0_17979_1009)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 13C9.75 10.4141 10.7772 7.93419 12.6057 6.10571C14.4342 4.27723 16.9141 3.25 19.5 3.25C22.0859 3.25 24.5658 4.27723 26.3943 6.10571C28.2228 7.93419 29.25 10.4141 29.25 13H30.875C31.737 13 32.5636 13.3424 33.1731 13.9519C33.7826 14.5614 34.125 15.388 34.125 16.25V32.5C34.125 33.362 33.7826 34.1886 33.1731 34.7981C32.5636 35.4076 31.737 35.75 30.875 35.75H8.125C7.26305 35.75 6.4364 35.4076 5.8269 34.7981C5.21741 34.1886 4.875 33.362 4.875 32.5V16.25C4.875 15.388 5.21741 14.5614 5.8269 13.9519C6.4364 13.3424 7.26305 13 8.125 13H9.75ZM19.5 6.5C21.2239 6.5 22.8772 7.18482 24.0962 8.40381C25.3152 9.62279 26 11.2761 26 13H13C13 11.2761 13.6848 9.62279 14.9038 8.40381C16.1228 7.18482 17.7761 6.5 19.5 6.5ZM22.75 22.75C22.75 23.3205 22.5998 23.8809 22.3146 24.375C22.0293 24.869 21.6191 25.2793 21.125 25.5645V27.625C21.125 28.056 20.9538 28.4693 20.649 28.774C20.3443 29.0788 19.931 29.25 19.5 29.25C19.069 29.25 18.6557 29.0788 18.351 28.774C18.0462 28.4693 17.875 28.056 17.875 27.625V25.5645C17.2555 25.2068 16.7713 24.6546 16.4975 23.9936C16.2237 23.3327 16.1757 22.5999 16.3609 21.9088C16.5461 21.2178 16.9541 20.6072 17.5216 20.1716C18.0892 19.7361 18.7846 19.5 19.5 19.5C20.362 19.5 21.1886 19.8424 21.7981 20.4519C22.4076 21.0614 22.75 21.888 22.75 22.75Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17979_1009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMingcuteLock);
export default __webpack_public_path__ + "static/media/mingcute_lock.e9fa96fd2ba12d7cc60120ff439751c6.svg";
export { ForwardRef as ReactComponent };